<div class="offcanvas offcanvas-end w-50"
  [class.show]="show"
  data-bs-scroll="true"
  data-bs-backdrop="false"
  tabindex="-1"
  id="offcanvasScrolling"
  aria-labelledby="offcanvasScrollingLabel"
  >
  <div class="offcanvas-header">
    <h5 class="offcanvas-title" id="offcanvasScrollingLabel">{{ newsItem?.title }}</h5>
    <button type="button" class="btn-close text-reset"
    data-bs-dismiss="offcanvas" aria-label="Close" (click)="close()"></button>
  </div>
  <div class="offcanvas-body">

    @if (renderedContent() == null || renderedContent() == '') {
      <div class="d-flex justify-content-center align-items-center">
        <div class="display-6">The news content will appear here</div>
      </div>
    }
    @else {
      <div [innerHTML]="renderedContent()"></div>
    }

  </div>
</div>
